angular.module('components.caOrderSearchResult', [])
    .component('caOrderSearchResult', {
        templateUrl: 'main/order/ordersearch/components/ordersearchresult.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            orders: '=',
            searchTerm: '=',
            currentPage: '=',
            totalItems: '=',
            limit: '=',
            orderTypes: '=',
            showUndeliveredOnly: '=',
            showUnprintedOnly: '=',
            showUnapprovedOnly: '=',
            useScannerNavigation: '=',
            onSearchTermChanged: '&',
            onOrderSelected: '&'
        },
        controller: ['OrdersApiService', 'ToasterService', 'loadSpinnerService', '$translate', '$scope', '$state', '$window', 'confirmationDialogService', '$rootScope', 'printPickingListDialogService', controller]
    });

// @ngInject
function controller(OrdersApiService, ToasterService, loadSpinnerService, $translate, $scope, $state, $window, confirmationDialogService, $rootScope, printPickingListDialogService) {
    var vm = this;

    //Properties
    var flexGridCurrentlySelectedItem = {};
    var orderSearchGrid = {};
    var wijmo = $window.wijmo;
    var showAllOrderTypes = false;
    vm.scannerInput = '';
    vm.contextMenuVisibility = {};
    vm.currentUserClaims = $rootScope.currentUser.claims;
    vm.hasClaim = havePurchaseCostClaim();

    //vm.monthsBack = null;
    vm.useMonthsBack = false;
    vm.monthsOptions = [1, 2, 4, 12, 18, 24, 36, 48];

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;
    vm.searchTermChanged = searchTermChanged;
    vm.transitionToState = transitionToState;
    vm.gridInitialization = gridInitialization;
    vm.gridSelectionChanged = gridSelectionChanged;
    vm.shouldShowInventoryReasonHeader = shouldShowInventoryReasonHeader;
    vm.shouldShowFromLocation = shouldShowFromLocation;
    vm.shouldShowSupplier = shouldShowSupplier;
    vm.shouldShowDestination = shouldShowDestination;
    vm.changeToStoreOrderSearch = changeToStoreOrderSearch;
    vm.changeToInternalOrderSearch = changeToInternalOrderSearch;
    vm.changeToAutoOrderSearch = changeToAutoOrderSearch;
    vm.changeToAutoOrderNormalSearch = changeToAutoOrderNormalSearch;
    vm.changeToAutoOrderInternalSearch = changeToAutoOrderInternalSearch;
    vm.changeToInventoryOrderSearch = changeToInventoryOrderSearch;
    vm.changeToReturnOrderSearch = changeToReturnOrderSearch;
    vm.changeToAllOrderSearch = changeToAllOrderSearch;
    vm.contextMenuEdit = contextMenuEdit;
    vm.contextMenuDeliver = contextMenuDeliver;
    vm.contextMenuCopy = contextMenuCopy;
    vm.contextMenuGetAsPdf = contextMenuGetAsPdf;
    vm.contextMenuGetAsCsv = contextMenuGetAsCsv;
    vm.contextMenuPrintLabel = contextMenuPrintLabel;
    vm.contextMenuDelete = contextMenuDelete;
    vm.contextMenuUndo = contextMenuUndo;
    vm.absolute = absolute;
    vm.togglePrintMode = togglePrintMode;
    vm.printSelectedOrders = printSelectedOrders;
    vm.printSelectedOrdersCsv = printSelectedOrdersCsv;
    vm.printSelectedOrderPickingLists = printSelectedOrderPickingLists;
    vm.deleteSelectedOrders = deleteSelectedOrders;
    vm.isAllowedToDeleteSelected = isAllowedToDeleteSelected;

    function onInit() {
        $window.addEventListener('click', hideContextMenuListener); // Cancel the context menu by clicking outside of it.
        setContextMenuShowAll();

        if (vm.useScannerNavigation) {
            angular.element("#scannerField").focus();
        }

        $("#scannerField").keydown(function (e) {
            var enterKeyCode = 13;
            if (e !== undefined && e.keyCode === enterKeyCode) {
                enterOrderByScannedBarcode(vm.scannerInput);
            }
        });
        activate();
    }
    function onChanges(changes) {

    }
    function onDestroy() {

    }
    function activate() {
        setInitialOrderTypes();

        $scope.$watch(function () { return vm.showUndeliveredOnly; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                searchTermChanged();
            }
        });

        $scope.$watch(function () { return vm.onlyOrderNumber; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                if(newValue){vm.onlyScan = false;}
            }
        });

        $scope.$watch(function () { return vm.onlyScan; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                if(newValue){vm.onlyOrderNumber = false;}
            }
        });

        $scope.$watch(function () { return vm.monthsBack; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                if (vm.useMonthsBack)
                    searchTermChanged();
            }
        });

        $scope.$watch(function () { return vm.useMonthsBack; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                if (!vm.useMonthsBack)
                    vm.monthsBack = null;
                else
                    vm.monthsBack = 12; // Default to 12 months

                searchTermChanged();
            }
        });
        $scope.$watch(function () { return vm.showUnprintedOnly; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                searchTermChanged();
            }
        });

        $scope.$watch(function () { return vm.showUnapprovedOnly; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                searchTermChanged();
            }
        });
    }

    function setInitialOrderTypes() {
        if (_.differenceWith(['Store', 'Internal', 'Automatic', 'AutomaticInternal', 'Inventory', 'Return'], vm.orderTypes, _.isEqual).length === 0) {
            showAllOrderTypes = true;
            vm.currentOrderListing = 'all';
        } else if (_.differenceWith(['Automatic'], vm.orderTypes, _.isEqual).length === 0) {
            showAllOrderTypes = false;
            vm.currentOrderListing = 'auto';
        } else if (_.differenceWith(['AutomaticInternal'], vm.orderTypes, _.isEqual).length === 0) {
            showAllOrderTypes = false;
            vm.currentOrderListing = 'autointernal';
        } else if (_.differenceWith(['Inventory'], vm.orderTypes, _.isEqual).length === 0) {
            showAllOrderTypes = false;
        } else if (_.differenceWith(['Return'], vm.orderTypes, _.isEqual).length === 0) {
            showAllOrderTypes = false;
            vm.currentOrderListing = 'return';
        } else if (_.differenceWith(vm.orderTypes, ['Internal'], _.isEqual).length === 0) {
            showAllOrderTypes = false;
            vm.currentOrderListing = 'internal';
        } else {
            //['Store']
            showAllOrderTypes = false;
            vm.currentOrderListing = 'store';
        }
    }

    function searchTermChanged() {
        if (vm.searchTerm !== undefined) {
            vm.onSearchTermChanged({
                searchTerms: {
                    searchTerm: vm.searchTerm,
                    currentPage: vm.currentPage,
                    totalItems: vm.totalItems,
                    limit: vm.limit,
                    orderTypes: vm.orderTypes,
                    showUndeliveredOnly: vm.showUndeliveredOnly,
                    showUnprintedOnly: vm.showUnprintedOnly,
                    showUnapprovedOnly: vm.showUnapprovedOnly,
                    onlyOrderNumber: vm.onlyOrderNumber,
                    monthsBack: vm.monthsBack
                }
            });
        }
    }

    function havePurchaseCostClaim() {
        if (vm.currentUserClaims.seepurchasecost === undefined) {
            return false
        }

        if (!vm.currentUserClaims.seepurchasecost.read) {
            return false
        }

        return true
    }

    function togglePrintMode(printModeType) {
        vm.showSelection = !vm.showSelection;
        if (printModeType !== undefined) {
            vm.printModeType = printModeType;
        } else {
            vm.printModeType = "none";
        }
    }

    function disablePrintMode() {
        vm.showSelection = false;
        vm.printModeType = "none";
    }

    function getSelectedOrderIds() {
        var ids = [];
        _.forEach(vm.orders, function (order) {
            if (order.isSelected) {
                ids.push(order.id);
            }
        });
        return ids;
    }

    function printSelectedOrders() {
        var ids = getSelectedOrderIds();
        if (ids.length !== 0) {
            loadSpinnerService.start('mainSpinner');
            OrdersApiService.getMultipleOrderPdf(ids).then(function (response) {
            }, function (error) {
                console.log(error);
            }).finally(function () {
                disablePrintMode();
                loadSpinnerService.stop('mainSpinner');
            });
        } else {
            disablePrintMode();
        }
    }

    function printSelectedOrdersCsv() {
        var ids = getSelectedOrderIds();
        if (ids.length !== 0) {
            loadSpinnerService.start('mainSpinner');
            OrdersApiService.getMultipleOrderCsv(ids).then(function (response) {
            }, function (error) {
                console.log(error);
            }).finally(function () {
                disablePrintMode();
                loadSpinnerService.stop('mainSpinner');
            });
        } else {
            disablePrintMode();
        }
    }

    function deleteSelectedOrders() {
        var ids = getSelectedOrderIds();
        var allowedToDelete = isAllowedToDeleteSelected();

        if (ids.length !== 0 && allowedToDelete) {

            confirmationDialogService.showDialog($translate.instant('order.confirmDeleteOrders')).then(function (result) {
                if (result === true) {
                    loadSpinnerService.start('mainSpinner');
                    OrdersApiService.deleteOrders(ids).then(function (response) {
                        vm.orders = _.reject(vm.orders, function (order) {
                            if (_.find(ids, function (id) { return order.id === id; })) {
                                return true;
                            }
                        });
                        orderSearchGrid.itemsSource = vm.orders;
                        orderSearchGrid.invalidate();
                        orderSearchGrid.collecitonView.refresh();
                    }, function (error) {
                        console.log(error);
                    }).finally(function () {
                        disablePrintMode();
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });

        } else if (!allowedToDelete) {
            ToasterService.showError('order.cannotDeleteOrders');
        } else {
            disablePrintMode();
        }
    }

    function isAllowedToDeleteSelected() {
        var orderIds = getSelectedOrderIds();
        var allowedToDelete = areAllOrdersDeleteable(orderIds);
        return allowedToDelete;
    }

    function areAllOrdersDeleteable(orderIds) {
        var isDeleteable = true;
        if (orderIds.length === 0) { return false; }

        var orders = _.filter(vm.orders, function (order) {
            return _.some(orderIds, function (orderId) { return order.id === orderId; });
        });

        _.forEach(orders, function (order) {
            if (order.systemStatus.toLowerCase() !== 'created') {
                isDeleteable = false;
            }
        });

        return isDeleteable;
    }

    function printSelectedOrderPickingLists() {
        var ids = getSelectedOrderIds();

        if (ids.length !== 0) {
            printPickingListDialogService.showDialog().then(function (result) {
                if (result.result === true) {
                    var request = {
                        orderIds: ids,
                        includeStorageLocation: result.includeStorageLocation,
                        includeIsPhotographed: result.includeIsPhotographed,
                        languageCode: result.languageCode,
                        grouping: result.grouping
                    };

                    loadSpinnerService.start('mainSpinner');
                    OrdersApiService.getMultipleOrderPickingListPdf(request).then(function (response) {
                    }, function (error) {
                        console.log(error);
                    }).finally(function () {
                        disablePrintMode();
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });

        } else {
            disablePrintMode();
        }
    }

    function transitionToState(id) {
        vm.onOrderSelected({ orderId: id });
    }

    function shouldShowInventoryReasonHeader () {
        return showAllOrderTypes && (_.includes(vm.orderTypes, 'Inventory'));
    }

    function shouldShowSupplier() {
        return showAllOrderTypes ||
            (_.includes(vm.orderTypes, 'Store') || _.includes(vm.orderTypes, 'Automatic') || _.includes(vm.orderTypes, 'Return'));
    }
    function shouldShowFromLocation() {
        return showAllOrderTypes ||
            (_.includes(vm.orderTypes, 'Internal') || _.includes(vm.orderTypes, 'AutomaticInternal') || _.includes(vm.orderTypes, 'Return'));
    }
    function shouldShowDestination() {
        return showAllOrderTypes ||
            (!_.includes(vm.orderTypes, 'Return'));
    }
    function changeToStoreOrderSearch() {
        vm.orderTypes = ['Store'];
        showAllOrderTypes = false;
        vm.currentOrderListing = 'store';
        searchTermChanged();
    }
    function changeToInternalOrderSearch() {
        vm.orderTypes = ['Internal'];
        showAllOrderTypes = false;
        vm.currentOrderListing = 'internal';
        searchTermChanged();
    }
    function changeToAutoOrderSearch() {
        vm.orderTypes = ['Automatic', 'AutomaticInternal'];
        showAllOrderTypes = false;
        searchTermChanged();
    }
    function changeToAutoOrderNormalSearch() {
        vm.orderTypes = ['Automatic'];
        showAllOrderTypes = false;
        vm.currentOrderListing = 'auto';
        searchTermChanged();
    }
    function changeToAutoOrderInternalSearch() {
        vm.orderTypes = ['AutomaticInternal'];
        showAllOrderTypes = false;
        vm.currentOrderListing = 'autointernal';
        searchTermChanged();
    }
    function changeToInventoryOrderSearch() {
        vm.orderTypes = ['Inventory'];
        showAllOrderTypes = false;
        searchTermChanged();
    }
    function changeToReturnOrderSearch() {
        vm.orderTypes = ['Return'];
        showAllOrderTypes = false;
        vm.currentOrderListing = 'return';
        searchTermChanged();
    }
    function changeToAllOrderSearch() {
        vm.orderTypes = ['Store', 'Internal', 'Automatic', 'AutomaticInternal', 'Inventory', 'Return'];
        showAllOrderTypes = true;
        vm.currentOrderListing = 'all';
        searchTermChanged();
    }

    function gridInitialization(flex) {
        orderSearchGrid = flex;
        var host = flex.hostElement;
        host.addEventListener('contextmenu', contextMenuListener);

        function contextMenuListener(event) {
            var jqContextMenu = $("#orderContextMenu");

            // Update selected row.
            var ht = flex.hitTest(event.pageX, event.pageY);
            flex.selection = new wijmo.grid.CellRange(ht.row, ht.col, ht.row, ht.col);

            flexGridCurrentlySelectedItem = flex.itemsSource[flex.selection.row];
            event.preventDefault();

            jqContextMenu.css("left", event.clientX);
            jqContextMenu.css("top", event.clientY);
            jqContextMenu.css("visibility", "visible");

            if (flexGridCurrentlySelectedItem.systemStatus.toLowerCase() === 'delivered') {
                vm.contextMenuVisibility.deliver = false;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }

        }
    }

    function gridSelectionChanged(e) {
        if (orderSearchGrid.itemsSource) {
            var clickedRowNumber = e.row;
            flexGridCurrentlySelectedItem = orderSearchGrid.itemsSource[clickedRowNumber];

            if (flexGridCurrentlySelectedItem.systemStatus.toLowerCase() === 'delivered') {
                vm.contextMenuVisibility.deliver = false;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }
        }
    }

    function contextMenuEdit() {
        console.log("[contextMenuEdit]: Not implemented.");
    }
    function contextMenuDeliver() {
        $state.go("order.orderdelivery", { orderId: flexGridCurrentlySelectedItem.id });
    }
    function contextMenuCopy() {
        $state.go("order.orderdelivery", { orderId: flexGridCurrentlySelectedItem.id });
    }
    function contextMenuGetAsPdf() {
        loadSpinnerService.start('mainSpinner');
        OrdersApiService.downloadAsPdf(flexGridCurrentlySelectedItem.id).then(function (response) {
        }, function (error) {
            ToasterService.showError(error.message);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }
    function contextMenuGetAsCsv() {
        loadSpinnerService.start('mainSpinner');
        OrdersApiService.downloadAsCsv(flexGridCurrentlySelectedItem.id).then(function (response) {
        }, function (error) {
            ToasterService.showError(error.message);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }
    function contextMenuPrintLabel() {
        loadSpinnerService.start('mainSpinner');
        OrdersApiService.downloadLabels(flexGridCurrentlySelectedItem.id, flexGridCurrentlySelectedItem.orderNumber).then(function (response) {
        }, function (error) {
            ToasterService.showError(error.message);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }
    function contextMenuDelete() {
        console.log("[contextMenuDelete]: Not implemented");
    }
    function contextMenuUndo() {
        console.log("[contextMenuUndo]: Not implemented");
    }
    function hideContextMenuListener(e) {
        var jqContextMenu = $("#orderContextMenu");
        jqContextMenu.css("visibility", "hidden");
        setContextMenuShowAll();
    }
    function setContextMenuShowAll() {
        vm.contextMenuVisibility = {
            edit: false,
            deliver: true,
            getAsPdf: true,
            getAsCsv: true,
            printLabel: true,
            delete: false,
            undo: false
        };
    }

    function enterOrderByScannedBarcode(scannedCode) {
        OrdersApiService.getByOrderNumber(scannedCode).then(function (response) {
            if (!response) {
                ToasterService.showError($translate.instant('salestotal.noRows'), $translate.instant('common.error'));
                return;
            }

            var destinationIsOk, fromLocationIsOk;
            var locationIds = _.map($rootScope.currentUser.locations, function (location) {
                return location.id;
            });
            if (response.destination) {
                destinationIsOk = _.find(locationIds, function (id) { return id === response.destination.id; });
            }
            if (response.fromLocation) {
                fromLocationIsOk = _.find(locationIds, function (id) { return id === response.fromLocation.id; });
            }
            if (!destinationIsOk && !fromLocationIsOk) {
                ToasterService.showError($translate.instant('order.mayNotAccessOrderLocation'), $translate.instant('common.error'));
                return;
            }

            if (response.systemStatus.toLowerCase() !== 'delivered') {
                $state.go('order.orderdelivery', { orderId: response.id, usingScannerNavigation: true });
            } else {
                vm.scannerInput = '';
                transitionToState(response.id);
            }
        }, function (error) {
            console.log(error);
        });
    }

    function absolute(number) {
        if (_.isNumber(number)) {
            return Math.abs(number);
        }
        return 0;
    }
}
